var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1366,
    height: 288,
    viewBox: "0 0 1366 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.55 292.184V59.3388H420.207V136.023H402.706V176.28H385.153L361.562 152.711V133.293H336.938V102.616H288.683V135.039H247.364V123.78H193.948V162.402H162.631V146.329H131.236V84.3455H103.41V102.719L87.1952 103.142V0L43.534 38.0036V137.051H25.6631V107.206H0V292.184H455.55ZM911.55 292.184V59.3388H876.207V136.023H858.706V176.28H841.153L817.562 152.711V133.293H792.938V102.616H744.683V135.039H703.364V123.78H649.948V162.402H618.631V146.329H587.236V84.3455H559.41V102.719L543.195 103.142V0L499.534 38.0036V137.051H481.663V107.206H456V292.184H911.55ZM1367.55 59.3388V292.184H912V107.206H937.663V137.051H955.534V38.0036L999.195 0V103.142L1015.41 102.719V84.3455H1043.24V146.329H1074.63V162.402H1105.95V123.78H1159.36V135.039H1200.68V102.616H1248.94V133.293H1273.56V152.711L1297.15 176.28H1314.71V136.023H1332.21V59.3388H1367.55Z",
    fill: "url(#paint0_linear_62_2877)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M682.515 243.476C797.675 243.476 891.03 228.408 891.03 209.82C891.03 191.232 797.675 176.164 682.515 176.164C567.355 176.164 474 191.232 474 209.82C474 228.408 567.355 243.476 682.515 243.476Z",
    fill: "url(#paint1_radial_62_2877)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.897,
    d: "M656.42 136.077H649.499V106.518C649.499 102.116 647.75 97.8936 644.637 94.7805C641.524 91.6674 637.301 89.9185 632.899 89.9185C628.496 89.9185 624.274 91.6674 621.161 94.7805C618.048 97.8936 616.299 102.116 616.299 106.518V136.077H609.383V106.518C609.383 100.281 611.861 94.299 616.271 89.8884C620.682 85.4778 626.664 83 632.901 83C639.139 83 645.121 85.4778 649.531 89.8884C653.942 94.299 656.42 100.281 656.42 106.518V136.077Z",
    fill: "url(#paint2_linear_62_2877)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M657.987 196.938H589L596.119 115.789H650.868L657.987 196.938Z",
    fill: "#ECEDF4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M676.799 196.938H607.812L614.931 115.789H669.681L676.799 196.938Z",
    fill: "url(#paint3_linear_62_2877)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M598.635 180.898L604.679 115.789H595.9L589 196.938L598.635 180.898Z",
    fill: "url(#paint4_linear_62_2877)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.601,
    d: "M589 196.94L598.617 180.469L608.207 196.94H589Z",
    fill: "url(#paint5_linear_62_2877)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_62_2877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M709.075 113.503L665.182 129.578C664.145 129.958 663.613 131.106 663.992 132.143L675.356 163.171C675.736 164.208 676.884 164.741 677.921 164.361L721.814 148.285C722.851 147.906 723.383 146.757 723.004 145.721L711.64 114.692C711.26 113.656 710.112 113.123 709.075 113.503Z",
    fill: "url(#paint6_linear_62_2877)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M708.94 154.313L706.972 155.029L698.866 132.758L698.772 132.792C699.119 134.505 698.839 136.286 697.984 137.81C697.129 139.335 695.755 140.502 694.112 141.099C693.855 141.193 693.57 141.18 693.321 141.064C693.072 140.948 692.88 140.738 692.786 140.48C692.692 140.222 692.704 139.938 692.82 139.689C692.936 139.44 693.147 139.248 693.404 139.154C694.533 138.746 695.488 137.963 696.107 136.935C696.726 135.907 696.973 134.697 696.806 133.508L666.896 144.394L666.187 142.445L691.294 133.307C690.248 132.622 689.485 131.581 689.146 130.377C688.808 129.173 688.916 127.887 689.452 126.757C689.988 125.627 690.914 124.729 692.061 124.229C693.207 123.729 694.496 123.661 695.689 124.037L694.296 120.209L696.262 119.493L697.656 123.321C698.321 122.253 699.352 121.464 700.557 121.102C701.762 120.74 703.058 120.829 704.201 121.354C705.345 121.878 706.258 122.802 706.77 123.951C707.281 125.1 707.356 126.397 706.981 127.598L713.883 125.085L714.591 127.032L702.897 131.289C703.532 132.308 704.499 133.077 705.634 133.467C706.77 133.858 708.005 133.845 709.133 133.431C709.391 133.337 709.675 133.35 709.924 133.466C710.173 133.582 710.365 133.792 710.459 134.05C710.553 134.308 710.541 134.593 710.425 134.841C710.309 135.09 710.099 135.283 709.841 135.377C708.199 135.974 706.396 135.963 704.762 135.345C703.127 134.727 701.768 133.543 700.932 132.008L700.839 132.042L708.944 154.313L708.94 154.313ZM700.689 123.07C699.96 123.335 699.366 123.88 699.038 124.583C698.709 125.286 698.673 126.09 698.938 126.82L699.938 129.569L702.69 128.568C703.057 128.441 703.396 128.243 703.687 127.985C703.977 127.726 704.213 127.412 704.38 127.061C704.548 126.71 704.644 126.33 704.663 125.941C704.681 125.553 704.623 125.165 704.49 124.799C704.357 124.434 704.152 124.099 703.888 123.813C703.624 123.528 703.306 123.298 702.952 123.137C702.598 122.976 702.216 122.887 701.827 122.875C701.438 122.864 701.051 122.93 700.689 123.07ZM693.351 125.74C692.983 125.867 692.644 126.065 692.354 126.323C692.063 126.582 691.828 126.896 691.66 127.247C691.492 127.598 691.396 127.978 691.378 128.367C691.359 128.755 691.418 129.143 691.551 129.509C691.684 129.874 691.888 130.209 692.152 130.495C692.416 130.78 692.734 131.01 693.088 131.171C693.442 131.332 693.825 131.421 694.213 131.433C694.602 131.444 694.989 131.378 695.352 131.239L698.103 130.237L697.102 127.488C696.836 126.759 696.291 126.166 695.588 125.838C694.884 125.511 694.08 125.476 693.351 125.74Z",
    fill: "#FAFAFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M665.461 197.96H721.684V149.137H665.461V197.96Z",
    fill: "url(#paint7_linear_62_2877)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.693,
    d: "M703.023 197.962H721.681V153.902H703.023V197.962Z",
    fill: "url(#paint8_linear_62_2877)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.492,
    d: "M665.461 197.962H685.797V154.625H665.461V197.962Z",
    fill: "url(#paint9_linear_62_2877)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M737.336 159.303C734.232 155.637 732.389 151.069 732.079 146.275C731.945 142.407 733.169 138.97 735.338 137.085C736.017 136.48 736.826 136.039 737.703 135.796C738.58 135.553 739.501 135.515 740.395 135.685C742.848 136.276 745.04 137.656 746.636 139.612C746.904 139.904 747.162 140.202 747.401 140.497C748.505 141.735 749.324 143.2 749.802 144.789C750.28 146.378 750.404 148.052 750.166 149.693C749.543 153.543 746.907 156.867 744.804 158.977C743.44 160.348 741.947 161.585 740.345 162.669L737.336 159.303ZM744.032 144.513C743.919 144.374 743.8 144.236 743.674 144.1C742.93 143.187 741.907 142.543 740.762 142.267C740.345 142.188 739.915 142.206 739.506 142.319C739.097 142.433 738.719 142.639 738.403 142.921C737.853 143.483 737.432 144.157 737.169 144.898C736.907 145.638 736.808 146.427 736.881 147.209C737.026 149.446 737.886 151.578 739.334 153.288L740.738 154.862C740.772 154.834 744.761 152.273 745.321 148.806C745.432 148.04 745.374 147.258 745.152 146.516C744.929 145.775 744.547 145.091 744.032 144.513Z",
    fill: "url(#paint10_linear_62_2877)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M742.895 166.169L740.23 162.525L740.24 162.517C741.632 161.179 743.148 159.978 744.769 158.931C747.269 157.311 751.065 155.423 754.961 155.613C756.615 155.722 758.226 156.192 759.68 156.989C761.133 157.787 762.395 158.892 763.376 160.229C763.615 160.525 763.853 160.839 764.082 161.162C765.663 163.13 766.556 165.562 766.624 168.085C766.603 168.995 766.374 169.887 765.954 170.694C765.534 171.502 764.934 172.201 764.201 172.74C761.908 174.48 758.297 174.959 754.54 174.021C749.916 172.721 745.834 169.968 742.895 166.169ZM758.748 162.691C758.29 162.067 757.7 161.551 757.021 161.179C756.342 160.808 755.59 160.589 754.818 160.539C751.335 160.37 747.978 163.731 747.945 163.764L749.188 165.459C750.56 167.234 752.466 168.52 754.625 169.127C755.375 169.361 756.167 169.429 756.945 169.326C757.723 169.222 758.47 168.951 759.133 168.529C759.475 168.279 759.755 167.953 759.951 167.577C760.148 167.201 760.255 166.785 760.266 166.361C760.234 165.182 759.817 164.047 759.078 163.128C758.971 162.976 758.859 162.829 758.748 162.691Z",
    fill: "url(#paint11_linear_62_2877)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M709.935 142.264L752.988 195.456L763.811 186.692L720.758 133.5L709.935 142.264Z",
    fill: "url(#paint12_linear_62_2877)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_62_2877",
    x: 659.869,
    y: 111.38,
    width: 67.2546,
    height: 59.1023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.9992
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9992
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.607843 0 0 0 0 0.658824 0 0 0 0 0.792157 0 0 0 0.502 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_62_2877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_62_2877",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_2877",
    x1: 1138,
    y1: 109.5,
    x2: 1134,
    y2: 478.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_62_2877",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(682.515 209.82) scale(208.515 33.656)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9",
    stopOpacity: 0.322
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_62_2877",
    x1: 632.901,
    y1: 53.8605,
    x2: 632.901,
    y2: 140.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5C0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC5EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_62_2877",
    x1: 730.057,
    y1: 196.938,
    x2: 591.945,
    y2: 196.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5C0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#F4E3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_62_2877",
    x1: 589,
    y1: 115.789,
    x2: 619.23,
    y2: 121.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5C0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC5EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_62_2877",
    x1: 589,
    y1: 201.535,
    x2: 600.313,
    y2: 168.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5C0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC5EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_62_2877",
    x1: 663.82,
    y1: 131.379,
    x2: 713.432,
    y2: 163.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#061C3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_62_2877",
    x1: 707.516,
    y1: 149.137,
    x2: 675.414,
    y2: 199.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B6E8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#D9C3ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_62_2877",
    x1: 713.453,
    y1: 166.856,
    x2: 713.453,
    y2: 230.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_62_2877",
    x1: 676.829,
    y1: 167.366,
    x2: 676.829,
    y2: 229.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_62_2877",
    x1: 722.85,
    y1: 156.96,
    x2: 758.675,
    y2: 127.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC5EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_62_2877",
    x1: 737.163,
    y1: 174.635,
    x2: 772.984,
    y2: 145.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC5EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_62_2877",
    x1: 776.805,
    y1: 221.078,
    x2: 785.691,
    y2: 142.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#DFC3ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login-bg.8db551ede866c9c901dd21e7bb26d0eb.svg";
export { ForwardRef as ReactComponent };